import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'app-true-false-input',
  templateUrl: './true-false-input.component.html',
  styleUrls: ['./true-false-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TrueFalseInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: TrueFalseInputComponent,
    },
  ],
})
export class TrueFalseInputComponent {
  @Input()
  title = "Select Option...";

  @Input()
  isDisabled = false;

  public value?: number;
  public localValue?: string;

  constructor() {
  }

  ngOnInit(): void {
  }

  onChange = (val: number | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val: any) {
    // Coerce robustly: ONLY an explicit yes (1 | '1' | true | 'true') is YES. The old `val ? 1 : 0`
    // treated the string '0' as truthy → the toggle rendered YES while the control still held '0'
    // (which persists as NO). Match strings AND numbers/booleans so a value from any source is safe.
    this.value =
      val === 1 || val === '1' || val === true || val === 'true' ? 1 : 0;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.unformatObject(this.value);
    }
  }

  toggle() {
    this.localValue = this.localValue?.toLocaleLowerCase() === 'yes' ? 'no' : 'yes';
    this.onValueChange(this.localValue);
  }

  onValueChange(val: string) {
    this.value = val.toLowerCase() == 'yes' ? 1 : 0;
    this.onChange(this.value);
this.writeValue(this.value);
  }

  formatObject(val: string) {
    return val.toLowerCase() == 'yes';
  }

  unformatObject(val: number) {
    return val ? 'YES' : 'NO';
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
